import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import boxes from 'public/assets/images/blog/boxes.jpg';

interface NewsContainerProps {
  image?: string;
}

export const Ancor = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  [theme.breakpoints.down('md')]: {
    minWidth: '100%',
  },
}));

export const NewsContainer = styled(Container)<NewsContainerProps>(({ theme, image }) => ({
  backgroundImage: `url(${image ?? boxes.src})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  minWidth: '17rem',
  height: '21rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'end',
  position: 'relative',
  borderRadius: '1rem',
  cursor: 'pointer',
  textAlign: 'left',
  '&:before': {
    content: "''",
    width: '100%',
    height: '100%',
    top: '0',
    right: '0',
    position: 'absolute',
    borderRadius: '1rem',
    backgroundImage: 'linear-gradient(to bottom, rgba(27, 52, 72, 0), #1b3448)',
  },
  [theme.breakpoints.down('md')]: {
    minWidth: '100%',
  },
}));

export const NewsTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  color: 'white',
  zIndex: '4',
  marginBottom: '1rem',
}));

export const NewsButton = styled('a')(({ theme }) => ({
  ...theme.typography.body2,
  color: 'white',
  zIndex: '4',
  margin: '1rem 0 1.3rem',
  cursor: 'pointer',
  textDecoration: 'none',
}));

export const Span = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const Categories = styled(Box)(({ theme }) => ({
  display: 'flex',
  zIndex: '4',
}));
